import { ReactNode, useCallback } from 'react';

import { PaloColumnFilter } from './palo-column-filter';
import { PaloListFilterField, usePaloListFilters } from './use-palo-list-filters';

/**
 * Fields a column gets a box for.
 *
 * A reference is an id, and nobody types one — those stay in the filter panel,
 * which has the autocomplete that turns a name into the id.
 */
const INLINE: PaloListFilterField['type'][] = ['text', 'number', 'money', 'date', 'choice', 'flag'];

/**
 * The filter row of a list, as far as the server declared one.
 *
 * A column is offered a box because the list said it can answer that field —
 * not because someone wired it up here as well. A list that declares nothing
 * gets no row at all and stays exactly as it was (#2209).
 */
export const usePaloColumnFilters = (listKey?: string): ((key: string) => ReactNode) => {
    const fields = usePaloListFilters(listKey);

    return useCallback(
        (key: string): ReactNode => {
            const field = fields.find(entry => entry.key === key);

            if (!field || !INLINE.includes(field.type)) {
                return null;
            }

            return <PaloColumnFilter field={field} />;
        },
        [fields]
    );
};
